import {FC, useLayoutEffect, useMemo, useState} from 'react';
//mui
import {Box, SxProps, Theme} from '@mui/material';
import {Color, ColorPicker as MuiColorPicker} from 'material-ui-color';
//formik
import {FieldInputProps, FormikProps} from 'formik';
//components
import FormHelperText from '../FormHelperText';
import InputLabel from '../Inputs/InputLabel';
//constants
import {STRING} from '@/utils/constants';
//styles
import {colorPickerStyle} from './ColorPicker.styles';

interface ColorPickerProps {
	field?: FieldInputProps<string>;
	form?: FormikProps<any>;
	label?: string;
	disabled?: boolean;
	disableErrorMessage?: boolean;
	parentClassName?: SxProps<Theme>;
	onChange?: (color: Color) => void;
}

const ColorPicker: FC<ColorPickerProps> = ({
	field,
	form,
	label,
	disabled,
	disableErrorMessage,
	parentClassName,
	onChange,
}) => {
	const [color, setColor] = useState<string>(field?.value || '');

	const errorText = useMemo(() => {
		return (field?.name && form?.touched[field?.name] && (form?.errors[field?.name] as string)) || undefined;
	}, [form?.errors, form?.touched, field]);

	useLayoutEffect(() => {
		if (field?.value !== color) {
			setColor(field?.value || '');
		}
	}, [field?.value]);

	const changeHandler = (color: Color) => {
		setColor(color as unknown as string);

		if (onChange) {
			onChange(color);
		} else if (field && form) {
			form.setFieldValue(
				field.name,
				typeof color === STRING ? (color as unknown as string) : color.css.backgroundColor
			);
		}
	};

	return (
		<Box sx={parentClassName}>
			{label && <InputLabel error={!!errorText} label={label} disabled={disabled} />}

			<Box
				sx={{
					...colorPickerStyle.content,
					...(disabled && colorPickerStyle.disabled),
					...(!!errorText && colorPickerStyle.error),
				}}
			>
				<MuiColorPicker value={color} onChange={changeHandler} disableAlpha />

				{!disableErrorMessage && errorText && <FormHelperText error title={errorText} />}
			</Box>

		</Box>
	);
};

export default ColorPicker;
